<template>
    <v-container>
      <v-dialog
          v-model="dialogZoomImage"
          scrollable
          width="900px"
      >
        <v-card>
          <v-toolbar flat class="mb-0" dark color="primary">
            <v-toolbar-title>
              {{$t('detalle_access_without_code')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn
                class="align-self-end"
                color="red"
                icon
                @click="dialogZoomImage = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="text-center">
            <image-zoom
                :regular="infoAccessWithoutCode.photo"
                :zoom-amount="3"
                :click-zoom="true"
                img-class="img-fluid"
                :zoom="infoAccessWithoutCode.photo">
            </image-zoom>
          </v-card-text>
        </v-card>
      </v-dialog>
        <!--    Diálogo para Mostrar la información de los Accesos sin Código   -->
        <v-dialog
            v-model="dialogDetailAccessWithoutCode"
            scrollable
            width="500"
        >
            <v-card color="blue-grey lighten-4" class="elevation-0">
                <v-toolbar class="mb-0" dark color="primary">
                    <v-toolbar-title>
                        {{$t('detalle_access_without_code')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogDetailAccessWithoutCode = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div class="text-xs-center">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12>
                                        <v-img
                                                @click="dialogZoomImage = true"
                                                :src="infoAccessWithoutCode.photo"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Visitante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccessWithoutCode.name_guest}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccessWithoutCode.house_address}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Vigilante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccessWithoutCode.vigilant_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('guardhouse_name_checkin')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccessWithoutCode.guardhouse_name_checkin === null ? 'N/A' : infoAccessWithoutCode.guardhouse_name_checkin}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('guardhouse_name_checkout')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccessWithoutCode.guardhouse_name_checkout === null ? 'N/A' :    infoAccessWithoutCode.guardhouse_name_checkout}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Notas')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccessWithoutCode.comments}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo para Mostrar la información de los Accesos sin Código   -->
        <v-dialog
            v-model="dialogDetailAccessWithoutCodeAdditionalPerson"
            scrollable
            width="500"
        >
            <v-card color="blue-grey lighten-4" class="elevation-0">
                <v-toolbar class="mb-0" dark color="primary">
                    <v-toolbar-title>
                        {{$t('additional_people')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogDetailAccessWithoutCodeAdditionalPerson = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div class="text-xs-center">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex v-for="(item, i) in infoAdditionalPeople" v-bind:key="i" class="text-xs-center" xs12>
                                        <v-img
                                                :src="item.photo"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('nombre')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ item.full_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo para Mostrar Placas del Vehiculo    -->
        <v-dialog
            v-model="dialogPlates"
            scrollable
            width="400"
        >
            <v-card color="blue-grey lighten-4" class="elevation-0">
                <v-toolbar class="mb-0" dark color="primary">
                    <v-toolbar-title>
                        {{$t('vehicle_plates')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogPlates = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-4">
                  <v-img
                      v-show="plates !== null"
                      :src="plates"
                      position="center center"
                      class="grey lighten-2"
                  ></v-img>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo para Mostrar la información de los Accesos    -->
        <v-dialog
            v-model="dialogDetailAccess"
            scrollable
            width="1000"
        >
            <v-card color="blue-grey lighten-4" class="elevation-0">
                <v-toolbar class="mb-0" dark color="primary">
                    <v-toolbar-title>
                        {{$t('detalle_access')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogDetailAccess = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <br>
                    <div class="text-xs-center" v-if="infoAccess.length > 0">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_invitado')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                v-if="getProfile.role === 1"
                                                :src="infoAccess[0].guestIdFront === null ? require('../../assets/noimage.png') : infoAccess[0].guestIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                        <v-img
                                                v-else-if="getProfile.role === 4 && getProfile.idHousingUnit === 'edfd9a1c-df93-4042-be50-f0ae04e079ce'"
                                                :src="infoAccess[0].guestIdFront === null ? require('../../assets/noimage.png') : infoAccess[0].guestIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                        <v-img
                                                v-else
                                                :src="infoAccess[0].guestAvatar === null ? require('../../assets/noimage.png') : infoAccess[0].guestAvatar"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                        <v-img
                                            v-if="infoAccess[0].vehicle_plates !== null"
                                            :src="infoAccess[0].vehicle_plates"
                                            position="center center"
                                            class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Visitante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="infoAccess[0].correction_request === false">
                                                        {{ infoAccess[0].guestFName}}
                                                        {{ infoAccess[0].guestLName}}
                                                    </h2>
                                                    <h2 v-else style="color: red">
                                                        {{ infoAccess[0].first_name}}
                                                        {{ infoAccess[0].last_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccess[0].guestCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        E-Mail:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccess[0].guestEmail}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Asunto')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccess[0].subject}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-show="infoAccess[0].correction_request === true" align-center justify-center row wrap>
                                    <v-btn
                                        disabled
                                        large
                                        color="error">
                                      {{$t('data_correction_sent')}}
                                    </v-btn>
                                </v-layout>
                            </v-flex>
                            <v-flex v-show="getProfile.role !== 2" xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_anfitrion')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <v-img
                                                :src="infoAccess[0].hostIdFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12 sm6>
                                        <table id="datas" style="width:100%">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Anfitrion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccess[0].hostFirstName}}
                                                        {{ infoAccess[0].hostLastName}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>{{$t('celular')}}:</h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccess[0].hostCellphone}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>E-Mail:</h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccess[0].hostEmail}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccess[0].street}} {{ infoAccess[0].numberHouse}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 class="text-xs-center edge pt-3 pb-3 pl-3 pr-3">
                                <h2>{{$t('info_acceso')}}</h2>
                                <br>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12>
                                        <v-img
                                                :src="infoAccess[0].guestIneFront"
                                                position="center center"
                                                class="grey lighten-2"
                                        ></v-img>
                                    </v-flex>
                                    <v-flex v-if="infoAccess[0].exit_photo" class="text-xs-center" xs12>
                                      <h2>{{$t('Foto de Salida')}}</h2>
                                      <v-img
                                          :src="infoAccess[0].exit_photo"
                                          position="center center"
                                          class="grey lighten-2"
                                          style="max-height: 300px"
                                      ></v-img>
                                    </v-flex>
                                    <v-flex class="text-xs-center" xs12>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_hora_acceso_in')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccess[0].dateTime_EntranceAccess}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('guardhouse_name_checkin')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccess[0].guardhouse_name_checkin === null ? 'N/A' : infoAccess[0].guardhouse_name_checkin}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_hora_acceso_out')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccess[0].dateTime_ExitAccess == null ? $t('pendiente')  : infoAccess[0].dateTime_ExitAccess }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('guardhouse_name_checkout')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccess[0].guardhouse_name_checkout === null ? 'N/A' :    infoAccess[0].guardhouse_name_checkout}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('estado')}}
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccess[0].status === 1 ? $t('adentro') : $t('completado')}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Notas')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoAccess[0].comments}}
                                                    </h2>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo para Mostrar el Detalle de la Invitación Recicida    -->
        <v-dialog
                v-model="dialogDetailInvitationReceived"
                scrollable
                width="700"
        >
            <v-card color="blue-grey lighten-4" class="elevation-0">
                <v-toolbar class="mb-0" dark color="primary">
                    <v-toolbar-title>
                        {{$t('detalle_invit_recibidas')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogDetailInvitationReceived = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div class="text-xs-center">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12>
                                <v-layout align-center justify-center row wrap>
                                    <v-flex class="text-xs-center" xs12>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_inv')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationReceived.date}}  {{ infoInvitationReceived.hour}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Anfitrion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationReceived.host_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <!--                                                <tr>-->
                                            <!--                                                    <th>-->
                                            <!--                                                        <h2>-->
                                            <!--                                                            {{$t('Empresa')}}:-->
                                            <!--                                                        </h2>-->
                                            <!--                                                    </th>-->
                                            <!--                                                    <td>-->
                                            <!--                                                        <h2>-->
                                            <!--                                                            {{ infoInvitationReceived[0].empresa}}-->
                                            <!--                                                        </h2>-->
                                            <!--                                                    </td>-->
                                            <!--                                                </tr>-->
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Fraccionamiento')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationReceived.residential_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationReceived.house_address}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Asunto')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationReceived.subject}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Notas')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationReceived.notes}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('mensaje_vehiculo')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationReceived.vehicle ? $t('Si') : "No" }}
                                                    </h2>
                                                </td>
                                            </tr>
<!--                                            <tr>-->
<!--                                                <th>-->
<!--                                                    <h2>-->
<!--                                                        {{$t('equipo_seguridad')}}-->
<!--                                                    </h2>-->
<!--                                                </th>-->
<!--                                                <td>-->
<!--                                                    <h3>-->
<!--                                                        <div v-for="(equipo, index) in infoInvitationReceived.secEqu" v-bind:key="equipo.index">-->
<!--                                                            <h3>{{index + 1}} .- {{ equipo.nameEquipment }}</h3>-->
<!--                                                        </div>-->
<!--                                                    </h3>-->
<!--                                                </td>-->
<!--                                            </tr>-->
                                            <tr v-if="infoInvitationReceived.type === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="infoInvitationReceived.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationReceived.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationReceived.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationReceived.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationReceived.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationReceived.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationReceived.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="infoInvitationReceived.type === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationReceived.expiration }}
                                                    </h2>
                                                </td>
                                            </tr>
<!--                                            <tr v-if="infoInvitationReceived.confirmed === false" align="center">-->
<!--                                                <td colspan="2" align-center>-->
<!--                                                    <h2>-->
<!--                                                        {{$t('asistira')}}:-->
<!--                                                    </h2>-->
<!--                                                    <v-btn-->
<!--                                                            color="primary"-->
<!--                                                            :loading="loading_si"-->
<!--                                                            @click="confirmarInvitacion(infoInvitationReceived.qr_code, 'True')"-->
<!--                                                            dark>{{$t('Si')}}-->
<!--                                                        <v-icon dark right>mdi-check-circle</v-icon>-->
<!--                                                    </v-btn>-->
<!--                                                    <v-btn-->
<!--                                                            color="red"-->
<!--                                                            :loading="loading_no"-->
<!--                                                            @click="confirmarInvitacion(infoInvitationReceived.qr_code, 'False')"-->
<!--                                                            dark>No-->
<!--                                                        <v-icon dark right>mdi-cancel</v-icon>-->
<!--                                                    </v-btn>-->
<!--                                                </td>-->
                                                <!--                                                    <td>-->
                                                <!--                                                        <h2>-->
                                                <!--                                                            {{ infoInvitationReceived.expiration }}-->
                                                <!--                                                        </h2>-->
                                                <!--                                                    </td>-->
<!--                                            </tr>-->
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo para Mostrar el Detalle de la Invitación Enviadada    -->
        <v-dialog
                v-model="dialogDetailInvitationSend"
                scrollable
                width="700"
        >
            <v-card color="blue-grey lighten-4" class="elevation-0">
                <v-toolbar class="mb-0" dark color="primary">
                    <v-toolbar-title>
                        {{$t('detalle_invit')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogDetailInvitationSend = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <div class="text-xs-center">
                        <v-layout justify-center class="text-xs-center" row wrap>
                            <v-flex xs12>
                                <v-layout align-center justify-center row wrap>
<!--                                    <h2>{{$t('info_invitado')}}</h2>-->
<!--                                    <v-flex class="text-xs-center" xs12 sm6>-->
<!--                                        <v-img-->
<!--                                                :src="infoInvitationSend.guest_ine_frente"-->
<!--                                                position="center center"-->
<!--                                                class="grey lighten-2"-->
<!--                                        ></v-img>-->
<!--                                    </v-flex>-->
                                    <v-flex class="text-xs-center" xs12>
                                        <table id="datas">
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Visitante')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationSend.guest_name}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('celular')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationSend.guest_number_phone}}
                                                    </h2>
                                                </td>
                                            </tr>
<!--                                            <tr>-->
<!--                                                <th>-->
<!--                                                    <h2>-->
<!--                                                        {{$t('Empresa')}}:-->
<!--                                                    </h2>-->
<!--                                                </th>-->
<!--                                                <td>-->
<!--                                                    <h2>-->
<!--                                                        {{ infoInvitationSend.empresa}}-->
<!--                                                    </h2>-->
<!--                                                </td>-->
<!--                                            </tr>-->
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('numero_casa')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationSend.house_address}}
                                                    </h2>
                                                </td>
                                            </tr>
<!--                                            <tr>-->
<!--                                                <th>-->
<!--                                                    <h2>-->
<!--                                                        {{$t('equipo_seguridad')}}-->
<!--                                                    </h2>-->
<!--                                                </th>-->
<!--                                                <td>-->
<!--                                                    <h3>-->
<!--                                                        <div v-for="(equipo, index) in infoInvitationSend.secEqu" v-bind:key="equipo.index">-->
<!--                                                            <h3>{{index + 1}} .- {{ equipo.nameEquipment }}</h3>-->
<!--                                                        </div>-->
<!--                                                    </h3>-->
<!--                                                </td>-->
<!--                                            </tr>-->
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Asunto')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationSend.subject}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_inv')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationSend.date}}  {{ infoInvitationSend.hour}}
                                                    </h2>
<!--                                                    <v-btn color="red"-->
<!--                                                           @click="setChangeHour(infoInvitationSend.qr_code, infoInvitationSend.timeInv)"-->
<!--                                                    >{{$t('modificar_hora')}}-->
<!--                                                    </v-btn>-->
                                                </td>
                                            </tr>
                                            <tr v-if="infoInvitationSend.type === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('dias_validos')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2 v-if="infoInvitationSend.diary.includes('0') === true">
                                                        {{ $t('Lunes') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationSend.diary.includes('1') === true">
                                                        {{ $t('Martes') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationSend.diary.includes('2') === true">
                                                        {{ $t('Miercoles') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationSend.diary.includes('3') === true">
                                                        {{ $t('Jueves') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationSend.diary.includes('4') === true">
                                                        {{ $t('Viernes') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationSend.diary.includes('5') === true">
                                                        {{ $t('Sabado') }}
                                                    </h2>
                                                    <h2 v-if="infoInvitationSend.diary.includes('6') === true">
                                                        {{ $t('Domingo') }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr v-if="infoInvitationSend.type === 2">
                                                <th>
                                                    <h2>
                                                        {{$t('fecha_expiracion')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationSend.expiration }}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('Notas')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationSend.notes}}
                                                    </h2>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>
                                                    <h2>
                                                        {{$t('mensaje_vehiculo')}}:
                                                    </h2>
                                                </th>
                                                <td>
                                                    <h2>
                                                        {{ infoInvitationSend.vehicle ? $t('Si') : "No" }}
                                                    </h2>
                                                </td>
                                            </tr>
<!--                                            <tr>-->
<!--                                                <th>-->
<!--                                                    <h2>-->
<!--                                                        {{$t('asistira')}}:-->
<!--                                                    </h2>-->
<!--                                                </th>-->
<!--                                                <td>-->
<!--                                                    <h2>-->
<!--                                                        {{ infoInvitationSend.confirmed ? $t('Si') : 'No' }}-->
<!--                                                    </h2>-->
<!--                                                </td>-->
<!--                                            </tr>-->
                                            <tr align="center">
                                                <td colspan="2">
                                                    <v-btn
                                                            color="primary"
                                                            large
                                                            :loading="loadingGafete"
                                                            @click="downloadGafete(infoInvitationSend)"
                                                    ><v-icon left>mdi-printer</v-icon>
                                                        {{$t('print_name_tag')}}
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </table>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
<!--                            <v-flex xs12>-->
<!--                                <h2>{{$t('info_anfitrion')}}</h2>-->
<!--                                <br>-->
<!--                                <v-layout align-center justify-center row wrap>-->
<!--                                    <v-flex class="text-xs-center" xs12 sm6>-->
<!--                                        <v-img-->
<!--                                                :src="infoInvitationSend.host_ine_frente"-->
<!--                                                position="center center"-->
<!--                                                class="grey lighten-2"-->
<!--                                        ></v-img>-->
<!--                                    </v-flex>-->
<!--                                    <v-flex class="text-xs-center" xs12 sm6>-->
<!--                                        <table id="datas" style="width:100%">-->
<!--                                            <tr>-->
<!--                                                <th>-->
<!--                                                    <h2>-->
<!--                                                        {{$t('Anfitrion')}}:-->
<!--                                                    </h2>-->
<!--                                                </th>-->
<!--                                                <td>-->
<!--                                                    <h2>-->
<!--                                                        {{ infoInvitationSend.hostFirstName}}-->
<!--                                                        {{ infoInvitationSend.hostLastName}}-->
<!--                                                    </h2>-->
<!--                                                </td>-->
<!--                                            </tr>-->
<!--                                            <tr>-->
<!--                                                <th>-->
<!--                                                    <h2>{{$t('celular')}}:</h2>-->
<!--                                                </th>-->
<!--                                                <td>-->
<!--                                                    <h2>-->
<!--                                                        {{ infoInvitationSend.host_celular}}-->
<!--                                                    </h2>-->
<!--                                                </td>-->
<!--                                            </tr>-->
<!--                                            <tr>-->
<!--                                                <th>-->
<!--                                                    <h2>{{$t('Area')}}:</h2>-->
<!--                                                </th>-->
<!--                                                <td>-->
<!--                                                    <h2>-->
<!--                                                        {{ infoInvitationSend.areaName}}-->
<!--                                                    </h2>-->
<!--                                                </td>-->
<!--                                            </tr>-->
<!--                                        </table>-->
<!--                                    </v-flex>-->
<!--                                </v-layout>-->
<!--                            </v-flex>-->
                        </v-layout>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo Modal para Confirmación Eliminar Invitación        -->
        <v-dialog
                v-model="dialogRemoveInvitation"
                max-width="500"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_cancelar_invitacion')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_eliminar_invitacion_2')}}
                </v-card-text>

                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="dialogRemoveInvitation = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="error"
                            @click="cancelInvitation(idInvitationToRemove)"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-layout calign-center >
            <v-flex>
                <v-card class="elevation-5">
                    <v-card-text>
                        <h3>{{$t('mostrando_historial_dia')}} </h3>
                        <v-form
                                @submit.prevent="submit()">
                            <v-layout class="align-center " row wrap>
                                <v-flex xs12 md6>
                                    <v-menu
                                            v-model="calendario"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="computedInitialDateFormatted"
                                                    :label="$t('initialDate')"
                                                    hint="DD/MM/YYYY"
                                                    persistent-hint
                                                    prepend-icon="mdi-calendar"
                                                    name="date"
                                                    readonly
                                                    v-on="on"
                                                    :error-messages="errores.date"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                :locale="$t('region')"
                                                v-model="date"
                                                @input="calendario = false">
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <v-flex xs12 md6>
                                    <v-menu
                                            v-model="calendario2"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                    v-model="computedFinalDateFormatted"
                                                    prepend-icon="mdi-calendar"
                                                    name="date2"
                                                    :label="$t('finalDate')"
                                                    readonly
                                                    hint="DD/MM/YYYY"
                                                    persistent-hint
                                                    v-on="on"
                                                    :error-messages="errores.date2"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker
                                                :locale="$t('region')"
                                                v-model="date2"
                                                @input="calendario2 = false">
                                        </v-date-picker>
                                    </v-menu>
                                </v-flex>
                                <br>
                                <v-flex xs6>
                                    <v-btn
                                            color="primary"
                                            type="submit"
                                            large
                                    >{{ $t('Filtrar') }}
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                        <br>
                        <v-layout calign-center v-if="getProfile.role !== 1 && getProfile.role !== 4">
                            <v-flex>
                                <v-card class="elevation-5">
                                    <v-toolbar dark color="primary">
                                        <v-toolbar-title>
                                            {{$t('Historial_Invitaciones_Enviadas')}}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-layout class="my-4" align-center justify-center fill-height>
                                            <v-flex >
                                                <v-data-table
                                                        :headers="headersInvitationsSend"
                                                        :loading="loadingDataInvitationsSend"
                                                        :items="invitationsSend"
                                                        :footer-props="{
                                                            itemsPerPageOptions: [
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}
                                                            ],
                                                            itemsPerPageText: $t('filas_por_pagina')
                                                        }"
                                                        class="elevation-1"
                                                        :no-data-text="$t('no_registros_invit')"
                                                >
                                                    <template v-slot:item.action="{ item }">
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        medium
                                                                        color="gray"
                                                                        class="mr-2"
                                                                        @click="get_detail(item.id)"
                                                                >
                                                                    mdi-magnify
                                                                </v-icon>
                                                            </template>
                                                            <span>{{$t('show_details')}}</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon
                                                                        v-show="!item.canceled"
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        medium
                                                                        color="red"
                                                                        class="mr-2"
                                                                        @click="dialogRemoveInvitation = true, idInvitationToRemove = item.id"
                                                                >
                                                                    mdi-cancel
                                                                </v-icon>
                                                            </template>
                                                            <span>{{$t('cancelar')}}</span>
                                                        </v-tooltip>
                                                    </template>
                                                    <template v-slot:item.type="{ item }">
                                                        {{item.type === 0 ? $t('normal') : '' }}
                                                        {{item.type === 1 ? $t('booth_registration') : '' }}
                                                        {{item.type === 2 ? $t('recurrente') : ''}}
                                                    </template>
                                                    <template v-slot:item.vehicle="{ item }">
                                                        {{item.vehicle === true ? $t('Si') : 'No' }}
                                                    </template>
                                                    <template v-slot:item.canceled="{ item }">
                                                      <v-chip
                                                          label
                                                          :color="item.canceled === true ? 'error' : 'success'"
                                                          dark
                                                      >
                                                        <v-icon left v-if="item.canceled">
                                                          mdi-cancel
                                                        </v-icon>
                                                        <v-icon left v-else>
                                                          mdi-check
                                                        </v-icon>
                                                        {{item.canceled === true ? $t('canceled') : $t('current') }}
                                                      </v-chip>
                                                    </template>
<!--                                                    <template v-slot:item.confirmed="{ item }">-->
<!--                                                        {{item.confirmed === true ? $t('Si') : 'No' }}-->
<!--                                                    </template>-->
                                                    <template v-slot:item.date="{ item }">
                                                        {{ item.date }} {{item.hour}}
                                                    </template>
                                                    <template v-slot:pageText="props">
                                                        {{props.rowsPerPage}}
                                                        {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout calign-center v-if="getProfile.role !== 4">
                            <v-flex>
                                <v-card class="elevation-5">
                                    <v-toolbar dark color="primary">
                                        <v-toolbar-title>
                                            {{$t('Historial_Invitaciones_Recibidas')}}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-layout class="my-4" align-center justify-center fill-height>
                                            <v-flex >
                                                <v-data-table
                                                        :headers="headersInvitationsReceived"
                                                        :loading="loadingDataInvitationsReceived"
                                                        :items="invitationsReceived"
                                                        :footer-props="{
                                                            itemsPerPageOptions: [
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}
                                                            ],
                                                            itemsPerPageText: $t('filas_por_pagina')
                                                        }"
                                                        class="elevation-1"
                                                        :no-data-text="$t('no_registros_invit')"
                                                >
                                                    <template v-slot:item.action="{ item }">
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        medium
                                                                        color="gray"
                                                                        class="mr-2"
                                                                        @click="get_detail_recibidas(item.id)"
                                                                >
                                                                    mdi-magnify
                                                                </v-icon>
                                                            </template>
                                                            <span>{{$t('show_details')}}</span>
                                                        </v-tooltip>
                                                    </template>
                                                    <template v-slot:item.type="{ item }">
<!--                                                        <td v-if="item.type === 0">{{ $t('normal') }}</td>-->
<!--                                                        <td v-if="item.type === 2">{{ $t('recurrente') }}</td>-->
                                                        {{item.type === 0 ? $t('normal') : '' }}
                                                        {{item.type === 1 ? $t('booth_registration') : '' }}
                                                        {{item.type === 2 ? $t('recurrente') : ''}}
                                                    </template>
                                                    <template v-slot:item.vehicle="{ item }">
                                                        {{item.vehicle === true ? $t('Si') : 'No' }}
                                                    </template>
                                                    <template v-slot:item.canceled="{ item }">
                                                      <v-chip
                                                          label
                                                          :color="item.canceled === true ? 'error' : 'success'"
                                                          dark
                                                      >
                                                        <v-icon left v-if="item.canceled">
                                                          mdi-cancel
                                                        </v-icon>
                                                        <v-icon left v-else>
                                                          mdi-check
                                                        </v-icon>
                                                        {{item.canceled === true ? $t('canceled') : $t('current') }}
                                                      </v-chip>
                                                    </template>
<!--                                                    <template v-slot:item.confirmed="{ item }">-->
<!--                                                        {{item.confirmed === true ? $t('Si') : 'No' }}-->
<!--                                                    </template>-->
                                                    <template v-slot:item.date="{ item }">
                                                        {{ item.date }} {{item.hour}}
                                                    </template>
                                                    <template v-slot:pageText="props">
                                                        {{props.rowsPerPage}}
                                                        {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout calign-center v-if="getProfile.role !== 3">
                            <v-flex>
                                <v-card class="elevation-5">
                                    <v-toolbar dark color="primary">
                                        <v-toolbar-title>
                                            {{$t('Historial_Accesos')}}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-layout class="my-4" align-center justify-center fill-height>
                                            <v-flex >
                                                <v-card-title class="justify-center">
                                                    <v-text-field
                                                            outlined
                                                            clearable
                                                            v-model="searchAccessCode"
                                                            append-icon="mdi-magnify"
                                                            :label="$t('Buscar')"
                                                            :placeholder="$t('search_by_name_visitor')"
                                                    ></v-text-field>
                                                </v-card-title>
                                                <v-data-table
                                                        :headers="getProfile.idHousingUnit === '9dbdc4ea-6909-4f99-95da-578b2f6de5f1' ? headersAccess : headersAccess2"
                                                        :loading="loadingDataAccess"
                                                        :search="searchAccessCode"
                                                        :items="access"
                                                        :footer-props="{
                                                            itemsPerPageOptions: [
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}
                                                            ],
                                                            itemsPerPageText: $t('filas_por_pagina')
                                                        }"
                                                        class="elevation-1"
                                                        :no-data-text="$t('no_registros_accesos')"
                                                >
                                                    <template v-slot:item.action="{ item }">
                                                        <v-tooltip bottom v-if="getProfile.role === 1 || getProfile.role === 2 || getProfile.role === 4">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        medium
                                                                        color="gray"
                                                                        class="mr-2"
                                                                        @click="get_access_detail(item.id)"
                                                                >
                                                                    mdi-magnify
                                                                </v-icon>
                                                            </template>
                                                            <span>{{$t('show_details')}}</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom v-else>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        medium
                                                                        color="gray"
                                                                        class="mr-2"
                                                                >
                                                                    mdi-information
                                                                </v-icon>
                                                            </template>
                                                            <span>{{$t('msg_info_details')}}</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom v-if="getProfile.role === 4 && item.vehicle_plates !== null">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        medium
                                                                        color="gray"
                                                                        class="mr-2"
                                                                        @click="plates = item.vehicle_plates, dialogPlates = true"
                                                                >
                                                                    mdi-camera
                                                                </v-icon>
                                                            </template>
                                                            <span>{{$t('show_vehicle_plates')}}</span>
                                                        </v-tooltip>
                                                    </template>
                                                    <template v-slot:item.status="{ item }">
                                                        <v-alert
                                                                class="mr-2"
                                                                v-show="item.status === 1"
                                                                type="warning">
                                                            {{$t('adentro')}}
                                                        </v-alert>
                                                        <v-alert
                                                                class="mr-2"
                                                                v-show="item.status === 2"
                                                                type="success">
                                                            {{$t('completado')}}
                                                        </v-alert>
                                                    </template>
                                                    <template v-if="getProfile.role === 4 || getProfile.role === 1" v-slot:item.dateTime_ExitAccess="{ item }">
                                                        <div v-if="item.dateTime_ExitAccess === null">
                                                            <v-btn
                                                                    @click="checkOutAccessCode(item.id)"
                                                                    color="primary">
                                                                {{$t('firmar')}}
                                                            </v-btn>
                                                        </div>
                                                        <div v-else>
                                                            {{item.dateTime_ExitAccess}}
                                                        </div>
                                                    </template>
                                                    <template v-else  v-slot:item.dateTime_ExitAccess="{ item }">
                                                        {{ item.dateTime_ExitAccess == null ? $t('pendiente')  : item.dateTime_ExitAccess }}
                                                    </template>
                                                    <template v-slot:item.guestFName="{ item }">
                                                        <v-tooltip v-if="item.correction_request === true" bottom>
                                                            <template v-slot:activator="{ on }">
                                                                <span v-on="on" style="color: red">
                                                                    {{ item.correction_request === true ? item.first_name : item.guestFName }} {{item.correction_request === true ? item.last_name : item.guestLName}}
                                                                </span>
                                                            </template>
                                                            <span>{{$t('data_correction_sent')}}</span>
                                                        </v-tooltip>
                                                        <v-tooltip v-else bottom>
                                                            <template v-slot:activator="{ on }">
                                                                <span v-on="on">
                                                                    {{ item.correction_request === true ? item.first_name : item.guestFName }} {{item.correction_request === true ? item.last_name : item.guestLName}}
                                                                </span>
                                                            </template>
                                                            <span></span>
                                                        </v-tooltip>
                                                    </template>
                                                    <template v-slot:item.hostFirstName="{ item }">
                                                        {{ item.hostFirstName }} {{item.hostLastName}}
                                                    </template>
                                                    <template v-slot:items="props">
                                                        <td>{{ props.item.dateTime_EntranceAccess }}</td>
                                                    </template>
                                                    <template v-slot:pageText="props">
                                                        {{props.rowsPerPage}}
                                                        {{$t('Accesos')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout calign-center v-if="getProfile.role === 1 || getProfile.role === 2 || getProfile.role === 4">
                            <v-flex>
                                <v-card class="elevation-5">
                                    <v-toolbar dark color="primary">
                                        <v-toolbar-title>
                                            {{$t('historial_accesos_sin_codigo')}}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-layout row wrap class="my-4" align-center justify-center fill-height>
                                            <v-flex>
                                                <v-card-title class="justify-center">
                                                    <v-text-field
                                                            outlined
                                                            clearable
                                                            v-model="searchAccessNoCode"
                                                            append-icon="mdi-magnify"
                                                            :label="$t('Buscar')"
                                                            :placeholder="$t('search_by_address_notes_name_guest')"
                                                    ></v-text-field>
                                                </v-card-title>
<!--                                            </v-flex>-->
<!--                                            <v-flex xs4 v-if="getProfile.role === 1 || getProfile.role === 4">-->
<!--                                                <v-card-title class="justify-center">-->
<!--                                                    <v-autocomplete-->
<!--                                                            v-model="idHouse"-->
<!--                                                            prepend-icon="mdi-home-city"-->
<!--                                                            name="idHouse"-->
<!--                                                            :item-text="example"-->
<!--                                                            item-value="address"-->
<!--                                                            :label="$t('casas')"-->
<!--                                                            :placeholder="$t('search_by_house_number')"-->
<!--                                                            :filter="customFilterHouse"-->
<!--                                                            :items="houses"-->
<!--                                                            no-data-text="Ningún Resultado"-->
<!--                                                            clearable-->
<!--                                                            outlined-->
<!--                                                            autocomplete="off"-->
<!--                                                    >-->
<!--                                                        <template v-slot:item="data">-->
<!--                                                            <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}}</strong>-->
<!--                                                        </template>-->
<!--                                                    </v-autocomplete>-->
<!--                                                </v-card-title>-->
<!--                                            </v-flex>-->
<!--                                            <v-flex xs12>-->
                                                <v-data-table
                                                        item-key="id"
                                                        :headers="getProfile.idHousingUnit === '9dbdc4ea-6909-4f99-95da-578b2f6de5f1' ? headersAccessWithoutCode : headersAccessWithoutCode2"
                                                        :loading="loadingDataAccessWithoutCode"
                                                        :items="accessWithoutCode"
                                                        :search="searchAccessNoCode"
                                                        :footer-props="{
                                                            itemsPerPageOptions: [
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}
                                                            ],
                                                            itemsPerPageText: $t('filas_por_pagina')
                                                        }"
                                                        class="elevation-1"
                                                        :no-data-text="$t('no_registros_accesos')"
                                                >
                                                    <template v-slot:item.action="{ item }">
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        medium
                                                                        color="gray"
                                                                        class="mr-2"
                                                                        @click="get_access_without_code_detail(item.id)"
                                                                >
                                                                    mdi-magnify
                                                                </v-icon>
                                                            </template>
                                                            <span>{{$t('show_details')}}</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        medium
                                                                        color="gray"
                                                                        class="mr-2"
                                                                        v-show="getProfile.idHousingUnit === '328c5156-d5fd-4558-a185-512fafd9eee1' && item.dateTime_ExitAccess == null && getProfile.role === 4"
                                                                        @click="printTicket(item)"
                                                                >
                                                                    mdi-printer
                                                                </v-icon>
                                                            </template>
                                                            <span>Imprimir Ticket</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom>
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        medium
                                                                        color="gray"
                                                                        class="mr-2"
                                                                        v-if="item.additionalPerson === true"
                                                                        @click="getAdditionalPeople(item.id)"
                                                                >
                                                                    mdi-account-group-outline
                                                                </v-icon>
                                                            </template>
                                                            <span>{{$t('show_additional_people')}}</span>
                                                        </v-tooltip>
                                                        <v-tooltip bottom v-if="getProfile.role === 1">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-icon
                                                                        v-bind="attrs"
                                                                        v-on="on"
                                                                        medium
                                                                        color="error"
                                                                        class="mr-2"
                                                                        @click="openRestrictedPersonDialog(item)"
                                                                >
                                                                    mdi-account-off
                                                                </v-icon>
                                                            </template>
                                                            <span>Agregar a lista de restricción</span>
                                                        </v-tooltip>
                                                    </template>
                                                    <template v-if="getProfile.role === 4" v-slot:item.dateTime_ExitAccess="{ item }">
                                                        <div v-if="item.dateTime_ExitAccess === null">
                                                            <v-btn
                                                                    @click="firmar(item.id, item)"
                                                                    color="primary">
                                                                {{$t('firmar')}}
                                                            </v-btn>
                                                        </div>
                                                        <div v-else>
                                                            {{item.dateTime_ExitAccess}}
                                                        </div>
                                                    </template>
                                                    <template v-else  v-slot:item.dateTime_ExitAccess="{ item }">
                                                        {{ item.dateTime_ExitAccess == null ? $t('pendiente')  : item.dateTime_ExitAccess }}
                                                    </template>
                                                    <template v-slot:item.cellNumber="{ item }">
                                                        <v-alert
                                                                class="mr-2"
                                                                v-show="item.dateTime_ExitAccess === null"
                                                                type="warning">
                                                            {{$t('adentro')}}
                                                        </v-alert>
                                                        <v-alert
                                                                class="mr-2"
                                                                v-show="item.dateTime_ExitAccess !== null"
                                                                type="success">
                                                            {{$t('completado')}}
                                                        </v-alert>
                                                    </template>
                                                    <template v-slot:items="props">
                                                        <td>{{ props.item.dateTime_EntranceAccess }}</td>
                                                    </template>
                                                    <template v-slot:pageText="props">
                                                        {{props.rowsPerPage}}
                                                        {{$t('Accesos')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout calign-center v-if="getProfile.role === 1 || getProfile.role === 2 || getProfile.role === 4">
                            <v-flex>
                                <v-card class="elevation-5">
                                    <v-toolbar dark color="primary">
                                        <v-toolbar-title>
                                            {{$t('Historial_Accesos_Trabajadores')}}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-layout class="my-4" align-center justify-center fill-height>
                                            <v-flex >
                                                <v-card-title class="justify-center">
                                                    <v-text-field
                                                            outlined
                                                            clearable
                                                            v-model="searchAccessWorker"
                                                            append-icon="mdi-magnify"
                                                            :label="$t('Buscar')"
                                                            :placeholder="$t('search_by_address_notes_name_guest')"
                                                    ></v-text-field>
                                                </v-card-title>
                                                <v-data-table
                                                        :headers="headersWorkerAccess"
                                                        :loading="loadingDataWorkersAccess"
                                                        :items="worker_access"
                                                        :search="searchAccessWorker"
                                                        :footer-props="{
                                                            itemsPerPageOptions: [
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}
                                                            ],
                                                            itemsPerPageText: $t('filas_por_pagina')
                                                        }"
                                                        class="elevation-1"
                                                        :no-data-text="$t('no_records_yet')"
                                                >
                                                  <template v-if="(getProfile.role === 4 || getProfile.role === 1) && getProfile.enable_manual_worker_check_out" v-slot:item.checkOut="{ item }">
                                                    <div v-if="item.checkOut === null">
                                                      <v-btn
                                                          @click="checkOutWorkerAccessCode(item.id)"
                                                          color="primary">
                                                        {{$t('firmar')}}
                                                      </v-btn>
                                                    </div>
                                                    <div v-else>
                                                      {{item.checkOut}}
                                                    </div>
                                                  </template>
                                                  <template v-else v-slot:item.checkOut="{ item }">
                                                    {{ item.checkOut == null ? $t('pendiente')  : item.checkOut }}
                                                  </template>
                                                  <template v-slot:pageText="props">
                                                    {{props.rowsPerPage}}
                                                    {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                  </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout calign-center v-if="(getProfile.role === 1 || getProfile.role === 2 || getProfile.role === 4) && getProfile.enable_biometric">
                            <v-flex>
                                <v-card class="elevation-5">
                                    <v-toolbar dark color="primary">
                                        <v-toolbar-title>
                                            {{$t('Historial_Accesos_Biometrico')}}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-layout class="my-4" align-center justify-center fill-height>
                                            <v-flex >
                                                <v-data-table
                                                        :headers="headersBiometricAccess"
                                                        :loading="loadingDataBiometricAccess"
                                                        :items="biometric_access"
                                                        :footer-props="{
                                                            itemsPerPageOptions: [
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}
                                                            ],
                                                            itemsPerPageText: $t('filas_por_pagina')
                                                        }"
                                                        class="elevation-1"
                                                        :no-data-text="$t('no_records_yet')"
                                                >
                                                    <template v-slot:pageText="props">
                                                        {{props.rowsPerPage}}
                                                        {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                    </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                          <v-layout calign-center v-if="(getProfile.role === 1 || getProfile.role === 4) && getProfile.contractors_enabled">
                            <v-flex>
                                <v-card class="elevation-5">
                                    <v-toolbar dark color="primary">
                                        <v-toolbar-title>
                                            {{$t('Historial_Accesos_Contratistas')}}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                      <v-card-text>
                                        <v-layout class="my-4" align-center justify-center fill-height>
                                            <v-flex >
                                                <v-data-table
                                                        :headers="headersContractorsAccess"
                                                        :loading="loadingDataContractorsAccess"
                                                        :items="contractors_access"
                                                        :footer-props="{
                                                            itemsPerPageOptions: [
                                                                {text: '5', value: 5},
                                                                {text: '10', value: 10},
                                                                {text: '25', value: 25},
                                                                {text: this.$t('todos'), value: -1}
                                                            ],
                                                            itemsPerPageText: $t('filas_por_pagina')
                                                        }"
                                                        class="elevation-1"
                                                        :no-data-text="$t('no_records_yet')"
                                                >
                                                  <template v-if="(getProfile.role === 4 || getProfile.role === 1) && getProfile.enable_manual_contractors_check_out" v-slot:item.checkOut="{ item }">
                                                    <div v-if="item.checkOut === null">
                                                      <v-btn
                                                          @click="checkOutContractorAccessCode(item.id)"
                                                          color="primary">
                                                        {{$t('firmar')}}
                                                      </v-btn>
                                                    </div>
                                                    <div v-else>
                                                      {{item.checkOut}}
                                                    </div>
                                                  </template>
                                                  <template v-else v-slot:item.checkOut="{ item }">
                                                    {{ item.checkOut == null ? $t('pendiente')  : item.checkOut }}
                                                  </template>
                                                  <template v-slot:pageText="props">
                                                    {{props.rowsPerPage}}
                                                    {{$t('Invitaciones')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                                                  </template>
                                                </v-data-table>
                                            </v-flex>
                                        </v-layout>
                                      </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <!-- Dialog for New Restricted Person -->
        <v-dialog v-model="restrictedPersonDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">Nueva Persona Restringida</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field v-model="personForm.fullName" label="Nombre Completo" required :error-messages="personFormErrors.fullName"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-textarea
                                        counter="500"
                                        maxlength="500"
                                        :rules="[v => !v || v.length <= 500 || 'Máximo 500 caracteres']"
                                        v-model="personForm.notes" label="Notas / Motivo general"
                                        rows="3"></v-textarea>
                            </v-col>
                            <v-col cols="12">
                                <v-switch v-model="personForm.isActive" label="Restricción Activa" color="red"></v-switch>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="personForm.startsAt" label="Fecha de Inicio" type="date" :error-messages="personFormErrors.startsAt"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="personForm.endsAt" label="Fecha de Fin (Opcional)" type="date"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-file-input
                                        v-model="personForm.photo"
                                        label="Foto de la Persona"
                                        accept="image/*"
                                        prepend-icon="mdi-camera"
                                        show-size
                                        clearable
                                ></v-file-input>
                            </v-col>
                            <v-col cols="12" v-if="previewPhotoUrl && !personForm.photo">
                                <div class="text-caption grey--text mb-1">Foto seleccionada:</div>
                                <v-img
                                        :src="previewPhotoUrl"
                                        max-height="150"
                                        max-width="150"
                                        contain
                                        class="rounded elevation-1"
                                ></v-img>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="restrictedPersonDialog = false">Cancelar</v-btn>
                    <v-btn color="blue darken-1" text @click="saveRestrictedPerson" :loading="savingPerson">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import JSPDF from 'jspdf'
import QRCode from 'qrcode'
import axios from 'axios'
import store from '@/store'
import { mapGetters } from 'vuex'
import { cacheAdapterEnhancer } from 'axios-extensions'
import imageZoom from 'vue-image-zoomer'

export default {
  name: 'historical',
  components: {
    imageZoom
  },
  data: () => ({
    dialogZoomImage: false,
    calendario: '',
    date: '',
    calendario2: '',
    date2: '',
    errores: [],
    fecha_actual: '',
    yyyy: '',
    mm: '',
    dd: '',
    yyyy2: '',
    mm2: '',
    dd2: '',
    headersInvitationsSend: [],
    loadingDataInvitationsSend: false,
    invitationsSend: [],
    headersInvitationsReceived: [],
    headersWorkerAccess: [],
    headersBiometricAccess: [],
    loadingDataInvitationsReceived: false,
    invitationsReceived: [],
    headersAccess: [],
    headersAccess2: [],
    loadingDataAccess: false,
    loadingDataWorkersAccess: false,
    loadingDataBiometricAccess: false,
    headersContractorsAccess: [],
    loadingDataContractorsAccess: false,
    access: [],
    worker_access: [],
    biometric_access: [],
    contractors_access: [],
    infoAccess: '',
    dialogDetailAccess: false,
    dialogPlates: false,
    plates: null,
    infoInvitationReceived: '',
    dialogDetailInvitationReceived: false,
    loading_si: false,
    loading_no: false,
    infoInvitationSend: '',
    dialogDetailInvitationSend: false,
    dialogRemoveInvitation: false,
    idInvitationToRemove: '',
    loadingGafete: false,
    headersAccessWithoutCode: [],
    headersAccessWithoutCode2: [],
    loadingDataAccessWithoutCode: false,
    accessWithoutCode: [],
    infoAccessWithoutCode: '',
    infoAdditionalPeople: [],
    dialogDetailAccessWithoutCode: false,
    dialogDetailAccessWithoutCodeAdditionalPerson: false,
    searchAccessNoCode: '',
    searchAccessWorker: '',
    searchAccessCode: '',
    idHouse: null,
    houses: [],
    // Restricted Person
    restrictedPersonDialog: false,
    savingPerson: false,
    previewPhotoUrl: '',
    personForm: {
      fullName: '',
      notes: '',
      isActive: true,
      startsAt: '',
      endsAt: '',
      photo: null
    },
    personFormErrors: {
      fullName: '',
      startsAt: ''
    }
  }),
  created () {
    this.fecha_actual = this.get_current_date()
    this.date = this.fecha_actual
    this.date2 = this.fecha_actual
    // if (this.getProfile.role === 1 || this.getProfile.role === 4) {
    // this.getHouses()
    // }
    this.getInvitationsSend(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    this.getInvitationsReceived(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    this.get_access_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    this.get_worker_access_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    this.get_contractor_access_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    this.get_biometric_access_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    this.get_all_access_without_code(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
  },
  beforeUpdate () {
    this.headersInvitationsSend = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('estado'),
        align: 'center',
        sortable: true,
        value: 'canceled'
      },
      {
        text: this.$t('Tipo'),
        align: 'center',
        sortable: true,
        value: 'type'
      },
      // {
      //   text: this.$t('asistira'),
      //   align: 'left',
      //   sortable: true,
      //   value: 'confirmed'
      // },
      {
        text: this.$t('fecha_hora'),
        align: 'center',
        sortable: true,
        value: 'date'
      },
      {
        text: this.$t('Visitante'),
        align: 'center',
        sortable: true,
        value: 'guest_name'
      },
      {
        text: this.$t('numero_casa'),
        align: 'center',
        sortable: true,
        value: 'house_address'
      },
      {
        text: this.$t('mensaje_vehiculo'),
        align: 'center',
        sortable: true,
        value: 'vehicle'
      }
    ]
    this.headersInvitationsReceived = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('estado'),
        align: 'center',
        sortable: true,
        value: 'canceled'
      },
      {
        text: this.$t('Tipo'),
        align: 'center',
        sortable: true,
        value: 'type'
      },
      // {
      //   text: this.$t('asistira'),
      //   align: 'left',
      //   sortable: true,
      //   value: 'confirmed'
      // },
      {
        text: this.$t('fecha_hora'),
        align: 'center',
        sortable: true,
        value: 'date'
      },
      {
        text: this.$t('Anfitrion'),
        align: 'left',
        sortable: true,
        value: 'host_name'
      },
      {
        text: this.$t('Fraccionamiento'),
        align: 'center',
        sortable: true,
        value: 'residential_name'
      },
      {
        text: this.$t('numero_casa'),
        align: 'left',
        sortable: true,
        value: 'house_address'
      },
      {
        text: this.$t('Asunto'),
        align: 'left',
        sortable: true,
        value: 'subject'
      },
      {
        text: this.$t('mensaje_vehiculo'),
        align: 'center',
        sortable: true,
        value: 'vehicle'
      }
    ]
    this.headersAccess = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Visitante'),
        align: 'left',
        sortable: true,
        value: 'guestFName'
      },
      {
        text: this.$t('estado'),
        align: 'left',
        sortable: true,
        value: 'status'
      },
      {
        text: this.$t('hora_acceso'),
        align: 'left',
        sortable: true,
        value: 'dateTime_EntranceAccess'
      },
      {
        text: this.$t('hora_salida'),
        align: 'left',
        sortable: true,
        value: 'dateTime_ExitAccess'
      },
      {
        text: this.$t('Anfitrion'),
        align: 'left',
        sortable: true,
        value: 'hostFirstName'
      },
      {
        text: this.$t('Notas'),
        align: 'center',
        sortable: true,
        value: 'comments'
      }
    ]
    this.headersAccess2 = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Visitante'),
        align: 'left',
        sortable: true,
        value: 'guestFName'
      },
      {
        text: this.$t('Vigilante'),
        align: 'center',
        sortable: false,
        value: 'vigilant_full_name_checkin'
      },
      {
        text: this.$t('estado'),
        align: 'left',
        sortable: true,
        value: 'status'
      },
      {
        text: this.$t('hora_acceso'),
        align: 'left',
        sortable: true,
        value: 'dateTime_EntranceAccess'
      },
      {
        text: this.$t('guardhouse_name_checkin'),
        align: 'center',
        sortable: true,
        value: 'guardhouse_name_checkin'
      },
      {
        text: this.$t('hora_salida'),
        align: 'left',
        sortable: true,
        value: 'dateTime_ExitAccess'
      },
      {
        text: this.$t('guardhouse_name_checkout'),
        align: 'center',
        sortable: true,
        value: 'guardhouse_name_checkout'
      },
      {
        text: this.$t('Anfitrion'),
        align: 'left',
        sortable: true,
        value: 'hostFirstName'
      },
      {
        text: this.$t('Notas'),
        align: 'center',
        sortable: true,
        value: 'comments'
      }
    ]
    this.headersWorkerAccess = [
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: true,
        value: 'first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'left',
        sortable: true,
        value: 'last_name'
      },
      {
        text: this.$t('direccion'),
        align: 'left',
        sortable: true,
        value: 'address'
      },
      {
        text: this.$t('hora_acceso'),
        align: 'left',
        sortable: true,
        value: 'checkIn'
      },
      {
        text: this.$t('hora_salida'),
        align: 'left',
        sortable: true,
        value: 'checkOut'
      },
      {
        text: this.$t('Notas'),
        align: 'center',
        sortable: true,
        value: 'comments'
      }
    ]
    this.headersContractorsAccess = [
      {
        text: this.$t('Nombre'),
        align: 'left',
        sortable: true,
        value: 'first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'left',
        sortable: true,
        value: 'last_name'
      },
      {
        text: this.$t('direccion'),
        align: 'left',
        sortable: true,
        value: 'address'
      },
      {
        text: this.$t('hora_acceso'),
        align: 'left',
        sortable: true,
        value: 'checkIn'
      },
      {
        text: this.$t('hora_salida'),
        align: 'left',
        sortable: true,
        value: 'checkOut'
      },
      {
        text: this.$t('Notas'),
        align: 'center',
        sortable: true,
        value: 'comments'
      }
    ]
    this.headersBiometricAccess = [
      {
        text: this.$t('direccion'),
        align: 'left',
        sortable: true,
        value: 'address'
      },
      {
        text: this.$t('nombre'),
        align: 'left',
        sortable: true,
        value: 'fullName'
      },
      {
        text: this.$t('fecha_hora_acceso_in'),
        align: 'left',
        sortable: true,
        value: 'dateTime'
      },
      {
        text: this.$t('acceso'),
        align: 'left',
        sortable: true,
        value: 'guardHouseName'
      }
    ]
    this.headersAccessWithoutCode = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('direccion'),
        align: 'left',
        sortable: true,
        value: 'address'
      },
      {
        text: this.$t('Visitante'),
        align: 'center',
        sortable: false,
        value: 'name_guest'
      },
      {
        text: this.$t('estado'),
        align: 'left',
        sortable: false,
        value: 'cellNumber'
      },
      {
        text: this.$t('hora_acceso'),
        align: 'center',
        sortable: true,
        value: 'dateTime_EntranceAccess'
      },
      {
        text: this.$t('hora_salida'),
        align: 'center',
        sortable: true,
        value: 'dateTime_ExitAccess'
      },
      {
        text: this.$t('Notas'),
        align: 'center',
        sortable: true,
        value: 'comments'
      }
    ]
    this.headersAccessWithoutCode2 = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('direccion'),
        align: 'left',
        sortable: true,
        value: 'address'
      },
      // {
      //   text: 'ID',
      //   width: '1%',
      //   align: 'center',
      //   sortable: false,
      //   value: 'house',
      //   filter: this.idHouseFilter
      // },
      {
        text: this.$t('Visitante'),
        align: 'center',
        sortable: false,
        value: 'name_guest'
      },
      {
        text: this.$t('Vigilante'),
        align: 'center',
        sortable: false,
        value: 'vigilant_full_name_checkin'
      },
      {
        text: this.$t('estado'),
        align: 'left',
        sortable: false,
        value: 'cellNumber'
      },
      // {
      //   text: this.$t('Vigilante'),
      //   align: 'center',
      //   sortable: true,
      //   value: 'vigilant_name',
      //   filterable: false
      // },
      {
        text: this.$t('hora_acceso'),
        align: 'center',
        sortable: true,
        value: 'dateTime_EntranceAccess'
      },
      {
        text: this.$t('guardhouse_name_checkin'),
        align: 'center',
        sortable: true,
        value: 'guardhouse_name_checkin'
      },
      {
        text: this.$t('hora_salida'),
        align: 'center',
        sortable: true,
        value: 'dateTime_ExitAccess'
      },
      {
        text: this.$t('guardhouse_name_checkout'),
        align: 'center',
        sortable: true,
        value: 'guardhouse_name_checkout'
      },
      {
        text: this.$t('Notas'),
        align: 'center',
        sortable: true,
        value: 'comments'
      }
    ]
  },
  computed: {
    ...mapGetters(['getProfile']),
    computedInitialDateFormatted () {
      return this.formatDate(this.date)
    },
    computedFinalDateFormatted () {
      return this.formatDate(this.date2)
    }
  },
  methods: {
    async printTicket (item) {
      try {
        const mmToPt = 2.83465
        const ticketW = 80 * mmToPt // Antes era 58
        const ticketH = 110 * mmToPt
        // Generar QR como Data URL
        const qrDataUrl = await QRCode.toDataURL(String(item.id), {
          width: 300,
          margin: 1,
          errorCorrectionLevel: 'M',
          color: { dark: '#000000', light: '#ffffff' }
        })
        const doc = new JSPDF('p', 'pt', [ticketW, ticketH])
        // Helper para centrar texto
        const centerText = (text, y) => {
          const textWidth = doc.getStringUnitWidth(text) * doc.internal.getFontSize() / doc.internal.scaleFactor
          const textOffset = (ticketW - textWidth) / 2
          doc.text(text, textOffset, y)
        }
        // Fondo blanco
        doc.setFillColor(255, 255, 255)
        doc.rect(0, 0, ticketW, ticketH, 'F')
        let currentY = 5 * mmToPt
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(8)
        doc.setTextColor(0, 0, 0)
        const divider = '================================'
        centerText(divider, currentY)
        currentY += 3.5 * mmToPt
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(9)
        centerText('Intrare Residencia', currentY)
        currentY += 3 * mmToPt
        // Nombre del fraccionamiento (sin logo)
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(7)
        const nameHULines = doc.splitTextToSize('Sierra Azul', ticketW - (6 * mmToPt))
        nameHULines.forEach(line => {
          centerText(line, currentY)
          currentY += 3 * mmToPt
        })
        currentY += 1 * mmToPt
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(8)
        centerText(divider, currentY)
        currentY += 5 * mmToPt
        const leftMargin = 14 * mmToPt // Antes era 6
        doc.setFontSize(7)
        doc.text(`Fecha: ${item.dateTime_EntranceAccess}`, leftMargin, currentY)
        currentY += 3.5 * mmToPt
        // Ajustar el nombre si es muy largo
        const nameLines = doc.splitTextToSize(`Visitante: ${item.name_guest}`, ticketW - (28 * mmToPt)) // Antes era 6
        nameLines.forEach(line => {
          doc.text(line, leftMargin, currentY)
          currentY += 3.5 * mmToPt
        })
        currentY += 1.5 * mmToPt
        doc.setFontSize(8)
        centerText(divider, currentY)
        currentY += 2 * mmToPt
        // QR Code (mismo tamaño)
        const qrSize = 35 * mmToPt
        const qrX = (ticketW - qrSize) / 2
        doc.addImage(qrDataUrl, 'PNG', qrX, currentY, qrSize, qrSize)
        currentY += qrSize + 3 * mmToPt
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(8)
        centerText(divider, currentY)
        currentY += 4 * mmToPt
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(8)
        centerText('IMPORTANTE', currentY)
        currentY += 4 * mmToPt
        doc.setFont('helvetica', 'normal')
        doc.setFontSize(7)
        centerText('Escanee el QR en el módulo', currentY)
        currentY += 3 * mmToPt
        centerText('de salida antes de retirarse.', currentY)
        currentY += 3 * mmToPt
        centerText('Válido una sola vez.', currentY)
        currentY += 5 * mmToPt
        centerText('Conserve este ticket hasta', currentY)
        currentY += 3 * mmToPt
        centerText('completar su salida.', currentY)
        currentY += 4 * mmToPt
        doc.setFont('helvetica', 'bold')
        doc.setFontSize(8)
        centerText('¡Gracias por su visita!', currentY)
        currentY += 4 * mmToPt
        doc.setFont('helvetica', 'italic')
        doc.setFontSize(5)
        try {
          const logoImg = new Image()
          logoImg.crossOrigin = 'Anonymous'
          logoImg.src = 'https://intrareres.s3.us-east-2.amazonaws.com/static/Icons/inrtare02.png'
          await new Promise((resolve, reject) => {
            logoImg.onload = resolve
            logoImg.onerror = reject
          })
          const poweredText = 'Powered by Intrare'
          const textWidth = doc.getStringUnitWidth(poweredText) * doc.internal.getFontSize() / doc.internal.scaleFactor
          const logoHeight = 10
          const logoWidth = logoHeight * (202 / 184)
          const spacing = 2
          const totalWidth = logoWidth + spacing + textWidth
          const startX = (ticketW - totalWidth) / 2
          doc.addImage(logoImg, 'PNG', startX, currentY - logoHeight + 2, logoWidth, logoHeight)
          doc.text(poweredText, startX + logoWidth + spacing, currentY)
        } catch (e) {
          console.error('Error loading logo image:', e)
          centerText('Powered by Intrare', currentY)
        }
        // Abrir PDF en nueva pestaña para imprimir
        const pdfBlob = doc.output('blob')
        const pdfUrl = URL.createObjectURL(pdfBlob)
        const printWindow = window.open(pdfUrl, '_blank')
        if (printWindow) {
          printWindow.addEventListener('load', () => {
            printWindow.print()
          })
        }
      } catch (err) {
        console.error('Error generando ticket:', err)
      }
    },
    get_current_date_menu () {
      let today = new Date()
      today.setDate(today.getDate() - 1)
      let dd = today.getDate()
      let mm = today.getMonth() + 1
      let yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }

      if (mm < 10) {
        mm = '0' + mm
      }
      today = yyyy + '-' + mm + '-' + dd
      return today
    },
    get_current_date_menu2 () {
      let today = new Date()
      let dd = today.getDate()
      let mm = today.getMonth() + 1
      let yyyy = today.getFullYear()

      if (dd < 10) {
        dd = '0' + dd
      }

      if (mm < 10) {
        mm = '0' + mm
      }
      today = yyyy + '-' + mm + '-' + dd
      return today
    },
    getHouses: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/house/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.houses = response.data
          // this.houses.push({
          //   id: null,
          //   idHousingUnit: null,
          //   inhabited: true,
          //   number: '',
          //   phone: null,
          //   phone2: null,
          //   phone3: null,
          //   street: 'Todas'
          // })
        })
        .catch(error => {
          console.log(error)
        })
    },
    example: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number),
    customFilterHouse (item, queryText) {
      var text = ''
      if (item.address === null || item.address === '') {
        text = 'n/a'
      } else {
        text = item.address.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    /**
     * Filter for calories column.
     * @param value Value to be tested.
     * @returns {boolean}
     */
    idHouseFilter (value) {
      // If this filter has no value we just skip the entire filter.
      if (this.idHouse === null || this.idHouse === undefined) {
        return true
      }
      // Check if the current loop value (The calories value)
      // equals to the selected value at the <v-select>.
      return value.toLowerCase().includes(this.idHouse.toLowerCase())
    },
    get_current_date () {
      var today = new Date()
      this.dd = today.getDate()
      this.mm = today.getMonth() + 1
      this.yyyy = today.getFullYear()
      this.dd2 = today.getDate()
      this.mm2 = today.getMonth() + 1
      this.yyyy2 = today.getFullYear()

      if (this.dd < 10) {
        this.dd = '0' + this.dd
      }
      if (this.dd2 < 10) {
        this.dd2 = '0' + this.dd2
      }
      if (this.mm < 10) {
        this.mm = '0' + this.mm
      }
      if (this.mm2 < 10) {
        this.mm2 = '0' + this.mm2
      }
      today = this.yyyy + '-' + this.mm + '-' + this.dd
      return today
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    submit () {
      this.split_date(this.date, this.date2)
      this.getInvitationsSend(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
      this.getInvitationsReceived(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
      this.get_access_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
      this.get_worker_access_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
      this.get_biometric_access_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
      this.get_all_access_without_code(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
    },
    split_date (date, date2) {
      var arr = date.split('-')
      var arr2 = date2.split('-')

      this.yyyy = arr[0]
      this.mm = arr[1]
      this.dd = arr[2]

      this.yyyy2 = arr2[0]
      this.mm2 = arr2[1]
      this.dd2 = arr2[2]
    },
    getInvitationsSend: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
      console.log(yyyy, mm, dd, '-', yyyy2, mm2, dd2)
      this.loadingDataInvitationsSend = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/Invitation/Host/Get/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          console.log('Respuesta')
          console.log(response)
          if (response.status === 204) {
            this.invitationsSend = []
          } else {
            this.invitationsSend = response.data
            console.log(this.access)
          }
          this.loadingDataInvitationsSend = false
        })
        .catch(error => {
          this.loadingDataInvitationsSend = false
          console.log(error)
        })
    },
    getInvitationsReceived: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
      this.loadingDataInvitationsReceived = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/Invitation/Guest/Get/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.invitationsReceived = []
          } else {
            this.invitationsReceived = response.data
          }
          this.loadingDataInvitationsReceived = false
        })
        .catch(error => {
          this.loadingDataInvitationsReceived = false
          console.log(error)
        })
    },
    get_access_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
      this.loadingDataAccess = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/Access/Get/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.access = []
          } else {
            this.access = response.data
            console.log(this.access)
          }
          this.loadingDataAccess = false
        })
        .catch(error => {
          this.loadingDataAccess = false
          console.log(error)
        })
    },
    get_contractor_access_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
      this.loadingDataContractorsAccess = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/contractorAccess/Get/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.contractors_access = []
          } else {
            this.contractors_access = response.data
            console.log(this.access)
          }
          this.loadingDataContractorsAccess = false
        })
        .catch(error => {
          this.loadingDataContractorsAccess = false
          console.log(error)
        })
    },
    get_worker_access_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
      this.loadingDataWorkersAccess = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/WorkerAccess/Get/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.worker_access = []
          } else {
            this.worker_access = response.data
            console.log(this.access)
          }
          this.loadingDataWorkersAccess = false
        })
        .catch(error => {
          this.loadingDataWorkersAccess = false
          console.log(error)
        })
    },
    get_biometric_access_by_date: function (yyyy, mm, dd, yyyy2, mm2, dd2) {
      this.loadingDataBiometricAccess = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/access_biometric_create_get/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.biometric_access = []
          } else {
            this.biometric_access = response.data
            console.log(this.access)
          }
          this.loadingDataBiometricAccess = false
        })
        .catch(error => {
          this.loadingDataBiometricAccess = false
          console.log(error)
        })
    },
    get_all_access_without_code (yyyy, mm, dd, yyyy2, mm2, dd2) {
      this.loadingDataAccessWithoutCode = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/access_no_code_create_get/' + yyyy + '/' + mm + '/' + dd + '/' + yyyy2 + '/' + mm2 + '/' + dd2 + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.accessWithoutCode = []
          } else {
            this.accessWithoutCode = response.data
            console.log(this.access)
          }
          this.loadingDataAccessWithoutCode = false
        })
        .catch(error => {
          this.loadingDataAccessWithoutCode = false
          console.log(error)
        })
    },
    get_access_detail (id) {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/Acess/Get/Search/' + id,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        adapter: cacheAdapterEnhancer(axios.defaults.adapter, { enabledByDefault: false })
      }
      axios(config)
        .then(response => {
          this.infoAccess = response.data
          this.dialogDetailAccess = true
        })
        .catch(error => {
          this.dialogDetailAccess = false
          console.log(error)
        })
    },
    get_access_without_code_detail (id) {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/access_no_code_get_detail_and_update_it/' + id + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.infoAccessWithoutCode = response.data
          this.dialogDetailAccessWithoutCode = true
        })
        .catch(error => {
          this.dialogDetailAccessWithoutCode = false
          console.log(error)
        })
    },
    getAdditionalPeople (id) {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/additional_people_no_code_get/' + id + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.infoAdditionalPeople = response.data
          this.dialogDetailAccessWithoutCodeAdditionalPerson = true
        })
        .catch(error => {
          this.dialogDetailAccessWithoutCodeAdditionalPerson = false
          console.log(error)
        })
    },
    get_detail_recibidas (id) {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/invitations/guest/' + id,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.infoInvitationReceived = response.data
          this.dialogDetailInvitationReceived = true
          console.log(this.infoInvitationReceived)
        })
        .catch(error => {
          this.dialogDetailInvitationReceived = false
          console.log(error)
        })
    },
    get_detail (id) {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/invitations/host/' + id,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.infoInvitationSend = response.data
          this.dialogDetailInvitationSend = true
        })
        .catch(error => {
          this.dialogDetailInvitationSend = false
          console.log(error)
        })
    },
    async openRestrictedPersonDialog (item) {
      const today = new Date().toISOString().split('T')[0]
      this.personForm = {
        fullName: item.name_guest || '',
        notes: '',
        isActive: true,
        startsAt: today,
        endsAt: '',
        photo: null
      }
      this.personFormErrors = { fullName: '', startsAt: '' }
      this.previewPhotoUrl = item.photo || ''
      this.restrictedPersonDialog = true

      if (item.photo) {
        try {
          const response = await fetch(item.photo)
          const blob = await response.blob()
          let ext = '.jpg'
          if (item.photo.includes('.png')) ext = '.png'
          const file = new File([blob], `photo${ext}`, { type: blob.type })
          this.personForm.photo = file
          this.previewPhotoUrl = ''
        } catch (e) {
          console.warn('No se pudo convertir la imagen a File', e)
        }
      }
    },
    renameWithUUID (file) {
      const uuid = crypto.randomUUID()
      const ext = file.name.includes('.') ? file.name.substring(file.name.lastIndexOf('.')) : ''
      const newName = `${uuid}${ext}`
      return new File([file], newName, { type: file.type, lastModified: file.lastModified })
    },
    formatDatePayload (dateStr) {
      if (!dateStr) return null
      return dateStr.includes('T') ? dateStr : dateStr + 'T00:00:00-06:00'
    },
    async saveRestrictedPerson () {
      this.personFormErrors = { fullName: '', startsAt: '' }
      if (!this.personForm.fullName) {
        this.personFormErrors.fullName = 'El nombre es requerido'
        return
      }
      if (!this.personForm.startsAt) {
        this.personFormErrors.startsAt = 'La fecha de inicio es requerida'
        return
      }
      this.savingPerson = true
      try {
        let personConfig = {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        }
        let personPayload
        if (this.personForm.photo instanceof File) {
          personPayload = new FormData()
          personPayload.append('fullName', this.personForm.fullName)
          personPayload.append('notes', this.personForm.notes || '')
          personPayload.append('isActive', this.personForm.isActive)
          personPayload.append('photo', this.renameWithUUID(this.personForm.photo))
          personConfig = { headers: { 'authorization': 'Token ' + store.getters.getToken } }
        } else {
          personPayload = {
            fullName: this.personForm.fullName,
            notes: this.personForm.notes,
            isActive: this.personForm.isActive
          }
        }
        const baseUrl = 'https://residencial-services.intrare.app'
        const personResponse = await axios.post(`${baseUrl}/people/`, personPayload, personConfig)
        const newPersonId = personResponse.data.id
        const rulePayload = {
          idRestrictedPerson: newPersonId,
          idHousingUnit: this.getProfile.idHousingUnit,
          reason: this.personForm.notes,
          startsAt: this.formatDatePayload(this.personForm.startsAt),
          isActive: true
        }
        if (this.personForm.endsAt) {
          rulePayload.endsAt = this.formatDatePayload(this.personForm.endsAt)
        } else {
          rulePayload.endsAt = null
        }
        await axios.post(`${baseUrl}/rules/`, rulePayload, {
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        })
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_message', 'Persona agregada a la lista de restricción')
        this.restrictedPersonDialog = false
        setTimeout(this.clear, 3000)
      } catch (error) {
        if (error.response && error.response.data && error.response.data.fullName) {
          this.personFormErrors.fullName = error.response.data.fullName
        } else {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', 'Error al guardar la persona restringida')
        }
        setTimeout(this.clear, 3000)
      } finally {
        this.savingPerson = false
      }
    },
    confirmarInvitacion (aQr, confirmacion) {
      if (confirmacion === 'True') {
        this.loading_si = true
      } else {
        this.loading_no = true
      }
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/Invitation/Confirmed/' + aQr + '/' + confirmacion + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(ok => {
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_invitacion_confirmada'))
          setTimeout(this.clear, 3000)
          this.dialogDetailInvitationReceived = false
          this.getInvitationsReceived(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
          if (confirmacion === 'True') {
            this.loading_si = false
          } else {
            this.loading_no = false
          }
        })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
          if (confirmacion === 'True') {
            this.loading_si = false
          } else {
            this.loading_no = false
          }
        })
    },
    firmar (pk, item) {
      console.log('UUID = ', pk)
      console.log('item = ', item)
      let index = this.accessWithoutCode.indexOf(item)
      console.log('index = ', index)
      console.log('data[index] = ', this.accessWithoutCode[index])
      // this.accessWithoutCode[index].dateTime_ExitAccess = '31/03/2025 19:40'
      // this.accessWithoutCode[index].guardhouse_name_checkout = 'Caseta de Pruebas'
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/access_no_code_get_detail_and_update_it/' + pk + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          id_guardhouse_checkout: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          this.accessWithoutCode[index].dateTime_ExitAccess = response.data.dateTime_ExitAccess
          this.accessWithoutCode[index].guardhouse_name_checkout = 'Pendiente'
          // this.get_all_access_without_code(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_exit_time_registered'))
          setTimeout(this.clear, 3000)
          // console.log('FIRMADO')
        })
        .catch(error => {
          console.log(error)
        })
    },
    checkOutAccessCode (pk) {
      // console.log('UUID = ', pk)
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/Access/Update/CheckOut/' + pk + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          id_guardhouse_checkout: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          this.get_access_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_exit_time_registered'))
          setTimeout(this.clear, 3000)
          // console.log('FIRMADO')
        })
        .catch(error => {
          console.log(error)
        })
    },
    checkOutContractorAccessCode (pk) {
      // console.log('UUID = ', pk)
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/contractorAccess/Update/CheckOut/' + pk + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          id_guardhouse_checkout: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          this.get_contractor_access_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_exit_time_registered'))
          setTimeout(this.clear, 3000)
          // console.log('FIRMADO')
        })
        .catch(error => {
          console.log(error)
        })
    },
    checkOutWorkerAccessCode (pk) {
      // console.log('UUID = ', pk)
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/WorkerAccess/Update/' + pk,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          id_guardhouse_checkout: localStorage.getItem('idGuardHouse')
        }
      }
      axios(config)
        .then(response => {
          this.get_worker_access_by_date(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_exit_time_registered'))
          setTimeout(this.clear, 3000)
          // console.log('FIRMADO')
        })
        .catch(error => {
          console.log(error)
        })
    },
    clear () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    cancelInvitation () {
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/Invitation/Canceled/' + this.idInvitationToRemove + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_canceled'))
        setTimeout(this.clear, 3000)
        this.dialogRemoveInvitation = false
        this.getInvitationsSend(this.yyyy, this.mm, this.dd, this.yyyy2, this.mm2, this.dd2)
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    xOffset: function (pdf, text) {
      return (
        pdf.internal.pageSize.width / 2) - (pdf.getStringUnitWidth(text) * pdf.internal.getFontSize() / 2)
    },
    getImgFromUrl (logoUrl, callback) {
      var img = new Image()

      img.src = logoUrl
      img.onload = function () {
        callback(img)
      }
    },
    downloadGafete (infoInvitationSend) {
      this.loadingGafete = true
      console.log('Datos de la Invitación: ')
      console.log(infoInvitationSend)
      // console.log(infoInvitationSend)
      const toDataUrl = (url, callback) => {
        const xhr = new XMLHttpRequest()
        xhr.onload = () => {
          const reader = new FileReader()
          reader.onloadend = () => {
            callback(reader.result)
          }
          reader.readAsDataURL(xhr.response)
        }
        xhr.open('GET', url)
        xhr.responseType = 'blob'
        xhr.send()
      }
      toDataUrl('https://api.qrserver.com/v1/create-qr-code/?data=' + infoInvitationSend.qr_code + '&ecc=M&margin=20&size=400x400', (qrCodeImage) => {
        var pdf = new JSPDF('portrait', 'pt', 'letter')
        // Black square with rounded corners
        pdf.setDrawColor(0)
        pdf.setFillColor(255, 255, 255)
        pdf.roundedRect(180, 50, 250, 400, 5, 5, 'FD')
        // pdf.setFontStyle('bold')
        // pdf.text(infoInvitationSend.housing_unit_name,
        //   this.xOffset(pdf, infoInvitationSend.housing_unit_name),
        //   100)
        pdf.setFontStyle('normal')
        pdf.setFontSize(16)
        pdf.text(this.$t('Visitante'),
          this.xOffset(pdf, this.$t('Visitante')),
          115)
        pdf.setFontStyle('bold')
        pdf.setFontSize(13)
        pdf.text(infoInvitationSend.guest_name,
          this.xOffset(pdf, infoInvitationSend.guest_name),
          130)
        pdf.setFontStyle('normal')
        pdf.setFontSize(16)
        pdf.text(this.$t('Anfitrion'),
          this.xOffset(pdf, this.$t('Anfitrion')),
          145)
        pdf.setFontStyle('bold')
        pdf.setFontSize(13)
        pdf.text(infoInvitationSend.host_name,
          this.xOffset(pdf, infoInvitationSend.host_name),
          160)
        pdf.setFontStyle('normal')
        pdf.setFontSize(16)
        pdf.text(this.$t('numero_casa'),
          this.xOffset(pdf, this.$t('numero_casa')),
          175)
        pdf.setTextColor('#000000')
        pdf.setFontStyle('bold')
        pdf.setFontSize(13)
        pdf.text(infoInvitationSend.house_address,
          this.xOffset(pdf, infoInvitationSend.house_address),
          190)
        pdf.setTextColor('#000000')
        pdf.setFontStyle('normal')
        pdf.setFontSize(16)
        pdf.text(this.$t('fecha_hora'),
          this.xOffset(pdf, this.$t('fecha_hora')),
          205)
        pdf.setFontStyle('bold')
        pdf.setFontSize(13)
        pdf.text(infoInvitationSend.date + ' ' + infoInvitationSend.hour,
          this.xOffset(pdf, infoInvitationSend.date + ' ' + infoInvitationSend.hour),
          220)
        pdf.setTextColor('#000000')
        pdf.setFontStyle('normal')
        pdf.setFontSize(16)
        pdf.text(this.$t('fecha_expiracion'),
          this.xOffset(pdf, this.$t('fecha_expiracion')),
          235)
        pdf.setFontStyle('bold')
        pdf.setFontSize(13)
        pdf.text(infoInvitationSend.expiration,
          this.xOffset(pdf, infoInvitationSend.expiration),
          250)
        pdf.setFontSize(6)
        pdf.setFontStyle('normal')
        pdf.text('El único objetivo del presente gafete es la de validar el acceso del portador',
          this.xOffset(pdf, 'El único objetivo del presente gafete es la de validar el acceso del portador'),
          410)
        pdf.text('mediante las reglas de operación del sistema Intrare Residencia. No existe',
          this.xOffset(pdf, 'mediante las reglas de operación del sistema Intrare Residencia. No existe'),
          418)
        pdf.text('relación laboral alguna entre el portador de este gafete ni con la empresa',
          this.xOffset(pdf, 'relación laboral alguna entre el portador de este gafete ni con la empresa'),
          426)
        pdf.text('Intrare Residencia ni con el fraccionamiento ' + infoInvitationSend.housing_unit_name + '.',
          this.xOffset(pdf, 'Intrare Residencia ni con el fraccionamiento ' + infoInvitationSend.housing_unit_name + '.'),
          434)
        // pdf.setLineWidth(4.0)
        // pdf.setDrawColor('#0000FF')
        // pdf.setFillColor('#FFFFFF')
        // pdf.roundedRect(212, 257, 186, 186, 5, 5, 'FD')
        // console.log(qrCodeImage); // qrCodeImage is the base64 string
        pdf.addImage(qrCodeImage, 'WEBP', 230, 254, 150, 150)
        toDataUrl(infoInvitationSend.logo, (logoGuest) => {
          pdf.addImage(logoGuest, 'WEBP', 190, 60, 50, 50)
          this.getImgFromUrl(require('../../assets/residencial_mx.png'), function (logoSystem) {
            pdf.addImage(logoSystem, 'WEBP', 370, 60, 50, 50)
            pdf.save('gafete.pdf')
          })
        })
        this.loadingGafete = false
      })
    }
  }
}
</script>

<style scoped>
    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #439f46;
        color: white;
    }
    .edge {
        border-radius: 8px;
        border-color: #439f46 #439f46 #439f46 #439f46;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
</style>
